import { z } from 'zod';
import { emailSchema, nameSchema } from './common.js';
import { passwordIssues, passwordSchema } from './password.js';
/**
 * Cadastro do PRIMEIRO usuario. Cria o household e o torna OWNER.
 * A partir do segundo, so por convite (regra 5.1 da especificacao).
 */
export const bootstrapSchema = z
    .object({
    name: nameSchema,
    email: emailSchema,
    password: passwordSchema,
    householdName: z.string().trim().min(2).max(120).default('Minha casa'),
})
    .superRefine((value, ctx) => {
    for (const issue of passwordIssues(value.password, { email: value.email, name: value.name })) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['password'], message: issue });
    }
});
export const acceptInviteSchema = z
    .object({
    token: z.string().min(20).max(200),
    name: nameSchema,
    password: passwordSchema,
})
    .superRefine((value, ctx) => {
    for (const issue of passwordIssues(value.password, { name: value.name })) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['password'], message: issue });
    }
});
/** Codigo TOTP de 6 digitos ou codigo de recuperacao. */
export const totpCodeSchema = z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'O codigo tem 6 digitos.');
export const recoveryCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/, 'Formato esperado: XXXX-XXXX-XXXX.');
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Informe a senha.').max(200),
    /** Enviado na segunda etapa, quando a primeira responde TOTP_REQUIRED. */
    totpCode: totpCodeSchema.optional(),
    recoveryCode: recoveryCodeSchema.optional(),
    deviceName: z.string().trim().max(80).optional(),
});
export const refreshSchema = z.object({
    /** Opcional: a web usa cookie httpOnly; o mobile manda no corpo. */
    refreshToken: z.string().min(20).max(500).optional(),
});
export const logoutSchema = refreshSchema;
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1).max(200),
    newPassword: passwordSchema,
    /** Encerra as demais sessoes. Padrao: sim. */
    revokeOtherSessions: z.boolean().default(true),
})
    .superRefine((value, ctx) => {
    if (value.currentPassword === value.newPassword) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['newPassword'],
            message: 'A nova senha precisa ser diferente da atual.',
        });
    }
});
export const totpConfirmSchema = z.object({
    code: totpCodeSchema,
});
export const totpDisableSchema = z.object({
    password: z.string().min(1).max(200),
    code: totpCodeSchema,
});
export const createInviteSchema = z.object({
    email: emailSchema,
    role: z.enum(['ADMIN', 'MEMBER', 'VIEWER']).default('MEMBER'),
});
export const revokeSessionSchema = z.object({
    sessionId: z.string().min(20).max(40),
});
// ---------------------------------------------------------------- respostas
export const authUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    totpEnabled: z.boolean(),
    role: z.enum(['OWNER', 'ADMIN', 'MEMBER', 'VIEWER']),
    householdId: z.string(),
    householdName: z.string(),
});
export const loginSuccessSchema = z.object({
    status: z.literal('authenticated'),
    accessToken: z.string(),
    accessTokenExpiresIn: z.number().int(),
    /** Presente apenas para clientes que nao usam cookie (mobile). */
    refreshToken: z.string().optional(),
    user: authUserSchema,
});
export const totpRequiredSchema = z.object({
    status: z.literal('totp_required'),
});
export const loginResponseSchema = z.discriminatedUnion('status', [
    loginSuccessSchema,
    totpRequiredSchema,
]);
export const totpSetupResponseSchema = z.object({
    secret: z.string(),
    otpauthUrl: z.string(),
    qrCodeDataUrl: z.string(),
});
export const recoveryCodesResponseSchema = z.object({
    recoveryCodes: z.array(z.string()),
});
export const sessionSchema = z.object({
    id: z.string(),
    device: z.string().nullable(),
    userAgent: z.string().nullable(),
    ipAddress: z.string().nullable(),
    createdAt: z.string(),
    lastUsedAt: z.string(),
    expiresAt: z.string(),
    current: z.boolean(),
});
export const sessionListSchema = z.object({ sessions: z.array(sessionSchema) });
//# sourceMappingURL=auth.js.map